

module.exports = __webpack_require__.stylable.create(
    "Spinner843214594",
    {"classes":{"root":"Spinner843214594__root","circle":"Spinner843214594__circle"},"vars":{},"stVars":{"DefaultPathColor":"\"color(color-5)\"","PathColor":"--overridable","UsedPathColor":"\"color(fallback(--overridable, color(color-5)))\""},"keyframes":{"rotate":"Spinner843214594__rotate","dash":"Spinner843214594__dash"}},
    "",
    1,
    "Spinner843214594",
    null
);
